import { useState, useEffect } from 'react';
import { GetWorkflowExecutionsForSpaceRequest, GetWorkflowExecutionsResponse } from '@amzn/finspace-service-typescript-client';
import { FinSpaceServiceApi } from '../finspaceServiceApi';
import { handleApiRequest } from '../utils/apiRequest';

export const useGetAllWorkflowExecutions = (spaceId: string | undefined) => {
  const [data, setData] = useState<GetWorkflowExecutionsResponse | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (!spaceId) return;

    let cancelled = false;

    const fetchAllWorkflowExecutions = async () => {
      setIsLoading(true);
      setData(undefined);
      try {
        const request: GetWorkflowExecutionsForSpaceRequest = { spaceId };
        const result = await handleApiRequest(() => FinSpaceServiceApi.getAllWorkflowExecutions(request));
        
        if (!cancelled) {
          setData(result as GetWorkflowExecutionsResponse);
          setError(null);
        }
      } catch (err) {
        console.error('Failed to fetch all workflow executions:', err);
        if (!cancelled) {
          setError(err);
          setData(undefined);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchAllWorkflowExecutions();

    return () => {
      cancelled = true;
    };
  }, [spaceId]);

  return { data, isLoading, error };
};
